var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgClock = function SvgClock(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.39 35.5a4 4 0 0 1 3.93 3.87v.2l-.5 24.5a4 4 0 0 1-8 .06v-.2l.5-24.5a4 4 0 0 1 4.07-3.93"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.56 80.75a4 4 0 0 1-5.51.05l-.15-.14-12.2-12.97c-1.53-1.59-2.49-5.12-.9-6.65a4 4 0 0 1 5.52-.05l.14.14 13.2 13.96a4 4 0 0 1-.1 5.66"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64 4a60 60 0 1 0 0 120A60 60 0 0 0 64 4m0 10a50 50 0 1 1 0 100 50 50 0 0 1 0-100"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgClock);
export default ForwardRef;